import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {NgbCalendar, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {useDefault} from '../../common/common';
import {NgRedux} from '@angular-redux/store';
import {IAppState} from '../../store/interfaces/IAppState';
import {DateUtils} from "../../common/date.utils";
import {APP_CONFIG} from "../../api/config/app.config";
import {IAppConfig} from "../../store/interfaces/IAppConfig";
import {DateRangeCommon} from "../../common/date-range/date-range.common";

@Component({
  selector: 'date-range-selector',
  templateUrl: './date-range-selector.component.html',
  styleUrls: ['./date-range-selector.component.scss']
})
export class DateRangeSelectorComponent extends DateRangeCommon {
  constructor(@Inject(APP_CONFIG) appConfig: IAppConfig,
               _ngRedux: NgRedux<IAppState>) {
    super(appConfig, _ngRedux);
    this.setDates();
  }

  setDates() {
    this.actualDate = new Date();
    this.maxDate = new Date();
    this.minMappedDate = this.toStruct(this.actualDate);
    this.maxDate.setMonth(this.actualDate.getMonth() + 12);
    this.maxMappedDate = this.toStruct(this.maxDate);
  };

  openCalendar(e: Event, order: number) {
    if (order === this.dateActions.CheckInClick) {
      this.minMappedDate = this.toStruct(this.actualDate);
      this._endDateStruct = this.toStruct(this._endDate);
      this.startCalendarDate = {year: this._startDate.getUTCFullYear(), month: this._startDate.getUTCMonth() + 1};
    } else if (order === this.dateActions.CheckOutClick) {
      this.minMappedDate = this._startDateStruct;
      this.startCalendarDate = {year: this._endDate.getUTCFullYear(), month: this._endDate.getUTCMonth() + 1}
    }
    this.order = order;
    this.showCalendar = true;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/date-range-selector/date-range-selector.component.ts